<template>
  <v-dialog :value="value" max-width="520" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="headline">{{ modeText }}</v-card-title>

      <v-card-text>
        <v-alert :value="!!message" :type="messageType" outline dense>
          {{ message }}
        </v-alert>

        <v-text-field
          v-if="step === 'password'"
          :value="password"
          label="Aktualne hasło"
          type="password"
          outlined
          @input="$emit('update-password', $event)"
        />

        <v-text-field
          v-else
          :value="code"
          label="Kod MFA"
          outlined
          autocomplete="one-time-code"
          @input="$emit('update-code', $event)"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn text :disabled="loading" @click="$emit('close')">Anuluj</v-btn>

        <v-btn v-if="step === 'code'" text :disabled="loading || resendSeconds > 0" @click="$emit('resend')">
          {{ resendText }}
        </v-btn>

        <v-btn color="primary" :loading="loading" @click="$emit('submit')">
          {{ verificationText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { buildMfaResendLabel } from '@/utils/mfa';

export default {
  name: 'MfaDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    step: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: ''
    },
    code: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    messageType: {
      type: String,
      default: 'info'
    },
    loading: {
      type: Boolean,
      default: false
    },
    resendSeconds: {
      type: Number,
      default: 0
    }
  },
  emits: ['input', 'update-password', 'update-code', 'close', 'submit', 'resend'],
  computed: {
    modeText() {
      return this.mode === 'enable' ? 'Włącz MFA' : 'Wyłącz MFA';
    },
    verificationText() {
      return this.step === 'password'
        ? 'Wyślij kod'
        : this.mode === 'enable'
        ? 'Zweryfikuj i włącz'
        : 'Zweryfikuj i wyłącz';
    },
    resendText() {
      return buildMfaResendLabel(this.resendSeconds);
    }
  }
};
</script>
